<div *ngIf="errorMessages" class="ir-messages-container">
    <div *ngFor="let error of errorMessages" class="ir-error-message">{{ error }}</div>
    <ng-content></ng-content>
</div>
